import {countries as countriesList} from 'countries-list';
import * as countryFlags from 'country-flag-icons/string/3x2';

export interface CountryInfo {
    name: string,
    isoCode2: string,
    flag?: string,
    phoneCode: string
}

export class CountryService {
    static countries: CountryInfo[] | undefined;
    static promise: Promise<CountryInfo[]> | undefined;

    static async fetchCountries(): Promise<CountryInfo[]> {

        const countries: CountryInfo[] = Object.entries(countriesList).map<CountryInfo>(([isoCode2, info]) => ({
            name: info.name,
            flag: (countryFlags as Record<string, string>)[isoCode2],
            phoneCode: info.phone,
            isoCode2
        }));

        return Promise.resolve(countries);
    }

    static async onlyCountries(countries: CountryInfo[], included: any)  {
        return countries?.filter((item) => included?.includes(item.isoCode2));
    }

    static async excludeCountries(countries: CountryInfo[], included: any) {
        return countries?.filter((item) => !included?.includes(item.isoCode2));
    }

    static async getCountries(extraOptions?: Record<string, string>) {
        //if (this.promise) return this.promise
        //if (this.countries) return Promise.resolve(this.countries)

        this.promise = this.fetchCountries();
        const res = await this.promise;

        if (extraOptions)
        {
            if (extraOptions?.['showCountriesInRedemptionForm'])
            {
                this.countries = await this.onlyCountries(res, extraOptions?.['showCountriesInRedemptionForm']);
            }
            else if (extraOptions?.['hideCountriesInRedemptionForm'])
            {
                this.countries = await this.excludeCountries(res, extraOptions?.['hideCountriesInRedemptionForm']);
            }
            else
            {
                this.countries = res;
            }
        }
        else
        {
            this.countries = res;
        }

        this.promise = undefined;

        return this.countries;

    }
}